module.exports = __webpack_public_path__ + "img/content-img5_3.eb8c74f6.png";